import React from "react";
import SVGIcon, { SVGIconName } from "web/react/components/svg-icon/svg-icon";
import { Heading } from "web/react/emo/heading/heading";
import { Text } from "web/react/emo/text/text";
import { VStack } from "web/react/emo/v-stack/v-stack";
import { useSectionImpression } from "web/react/pages/partners/use-section-impression";
import { gettext, gettextNoop } from "web/script/modules/django-i18n";
import * as styles from "./partners-trust.css";

interface CardConfig {
    icon: SVGIconName;
    titleKey: string;
    bodyKey: string;
}

const CARDS: CardConfig[] = [
    {
        icon: "padlock",
        titleKey: gettextNoop("partners.trust.card_4_title"),
        bodyKey: gettextNoop("partners.trust.card_4_body"),
    },
    {
        icon: "shield-verified",
        titleKey: gettextNoop("partners.trust.card_1_title"),
        bodyKey: gettextNoop("partners.trust.card_1_body"),
    },
    {
        icon: "success-circle",
        titleKey: gettextNoop("partners.trust.card_2_title"),
        bodyKey: gettextNoop("partners.trust.card_2_body"),
    },
    {
        icon: "price-change",
        titleKey: gettextNoop("partners.trust.card_3_title"),
        bodyKey: gettextNoop("partners.trust.card_3_body"),
    },
];

export default function PartnersTrust(): JSX.Element {
    const sectionRef = useSectionImpression("trust_and_compliance", 6);

    return (
        <section ref={sectionRef} id="trust-and-compliance" className={styles.section}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <VStack spacing="xs">
                        <Text textStyle="caption-s" color="secondary" className={styles.eyebrow}>
                            {gettext("partners.nav.trust_and_compliance")}
                        </Text>
                        <Heading textStyle="hero-l" as="h2">
                            {gettext("partners.trust.headline")}
                        </Heading>
                    </VStack>
                </div>

                <div className={styles.grid}>
                    {CARDS.map(({ icon, titleKey, bodyKey }) => (
                        <div key={titleKey} className={styles.card}>
                            <SVGIcon name={icon} className={styles.cardIcon} />
                            <VStack spacing="sm">
                                <Heading textStyle="hero-xs" as="h3">
                                    {gettext(titleKey)}
                                </Heading>
                                <Text textStyle="body" color="secondary" as="p">
                                    {gettext(bodyKey)}
                                </Text>
                            </VStack>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
